import type { QueryClient } from "@tanstack/react-query";
import { PUBLIC_CONFIG_QUERY_KEY } from "@/lib/maintenance";

export const AUTH_QUERY_KEY = ["auth", "me"] as const;

export function clearUserQueries(queryClient: QueryClient) {
  queryClient.removeQueries({
    predicate: (cachedQuery) =>
      cachedQuery.queryKey[0] !== AUTH_QUERY_KEY[0]
      && cachedQuery.queryKey[0] !== PUBLIC_CONFIG_QUERY_KEY[0],
  });
}

export function clearUserQueriesForIdentityChange(
  queryClient: QueryClient,
  previousUserId: string | null | undefined,
  nextUserId: string | null | undefined,
) {
  if (!previousUserId || previousUserId === nextUserId) return false;
  clearUserQueries(queryClient);
  return true;
}
